// Components==============
import { EditableProcessEntity } from 'hooks/useProcessGroups';
import { useRedux } from 'hooks/useRedux';
import React, { createContext, useContext } from 'react';
import {
  Draggable,
  DraggableProvidedDragHandleProps,
} from 'react-beautiful-dnd';
import { ProjectProcessContext } from '../../ProjectProcess';
import AddSwitchButton from '../AddSwitchModalButton/AddSwitchModalButton';
import Bottom from './Bottom/Bottom';
import './Process.module.scss';
import Top from './Top/Top';
// =========================

type Props = {
  editableProcess?: EditableProcessEntity;
  phase: number;
  phaseIndex: number;
  processIndex: number;
  dragHandleProps?: DraggableProvidedDragHandleProps;
  index: number;
  onbekend?: boolean;
};

export const ProcessContext = createContext(
  {} as Props & { process?: ProcessProcessEntity; canDeletePhase: boolean }
);

const DraggableProcess = () => {
  const { isEditable } = useContext(ProjectProcessContext);
  const { editableProcess, index, onbekend } = useContext(ProcessContext);

  const uniqueKey = `${editableProcess?.process_type}-${
    editableProcess?.id || 0
  }-${index}
  }`;

  return (
    <Draggable
      draggableId={uniqueKey}
      key={uniqueKey}
      index={index}
      isDragDisabled={!isEditable}
    >
      {(provided) => (
        <div
          styleName={`wrapper ${
            editableProcess?.process_type !== 'App\\Phase' ? 'activity' : ''
          }`}
          ref={provided.innerRef}
          {...provided.draggableProps}
        >
          <Top />
          <Bottom
            processDragHandler={provided.dragHandleProps}
            onbekend={onbekend}
          />
        </div>
      )}
    </Draggable>
  );
};

export default function Process({
  editableProcess,
  phase,
  phaseIndex,
  processIndex,
  lastOfGroup,
  dragHandleProps,
  index,
  onbekend,
}: Props & { lastOfGroup: boolean }) {
  const { isEditable, processGroups } = useContext(ProjectProcessContext);

  const process = useRedux((state) =>
    editableProcess?.processId
      ? state.process?.entities.byId[editableProcess?.processId]
      : undefined
  );

  const firstPhase = processIndex === 1 && phaseIndex === 1;

  const activityLength = processGroups?.find(
    (group) => group.processId === editableProcess?.processId
  )?.activities.length;

  const canDeletePhase = firstPhase ? (activityLength || 0) <= 1 : true;

  return (
    <ProcessContext.Provider
      value={{
        editableProcess,
        process,
        phase,
        phaseIndex,
        processIndex,
        dragHandleProps,
        index,
        canDeletePhase,
        onbekend,
      }}
    >
      {/* This is the phase */}
      {dragHandleProps ? (
        <div styleName="wrapper">
          <Top />
          <Bottom />
        </div>
      ) : (
        // * These are the activities
        <DraggableProcess />
      )}
      {isEditable && (
        <div styleName={`add-switch ${lastOfGroup ? 'last-of-group' : ''}`}>
          <AddSwitchButton fn="add" permission={'App\\Activity'} />
        </div>
      )}
    </ProcessContext.Provider>
  );
}
